/**!
 * Created by Leonardo Cheslacki on 02/06/2022.
 *
 * MIT License
 *
 * Copyright (c) 2022 cheslacki
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import Big from 'big.js';

import Moment from 'moment';

import 'moment/locale/pt-br';

Moment.locale('pt-br');

import {HelpersLanguage} from './';

let _this = {};

class HelpersController {
    /**
     *
     */
    constructor() {
        _this = this;
        this.$FormData = (new FormData());
        this.$XMLHttpRequest = (new XMLHttpRequest());
        this.$hours = parseInt(Moment().format('H'));
        this.$laguage = HelpersLanguage().get();
        this.$timer = [];
        this.$listeners = [];
        this.$controller = {
            timer_delay: 3000,
            big_division_100: (new Big(100)),
            big_division_2: (new Big(2))
        }
    }

    /**
     *
     * @protected
     */
    _void = () => {
    }

    /**
     *
     * @param state
     * @param callback
     */
    setState = (state, callback) => {
        this.state = state;
        (typeof (callback) === 'function') && callback(true);
    };

    /**
     *
     * @param field
     * @returns {string}
     */
    getState = (field) => {
        return this.verifyField(this.state, field, false, null);
    };

    /**
     *
     * @param object
     * @param callback
     */
    setStates = (object, callback) => {
        /**
         *
         * @param state
         * @param object
         * @param callback
         */
        const changeState = (state, object, callback) => {
            if (this.isObjectIf(object)) {
                this.defineObject(object);

                let
                    i = 0,
                    changed = false;

                for (let key in object) {
                    ++i;
                    if (object.hasOwnProperty(key)) {
                        if (state.hasOwnProperty(key) && this.isObjectIf(state[key])) {
                            changeState((this.isObject(state[key]) ? state[key] : state), object[key], (value) => {
                                state = {...state, [key]: value};
                                changed = true;
                            });
                        } else if (state.hasOwnProperty(key) && Array.isArray(state[key]) && Array.isArray(object[key])) {
                            state = {...state, [key]: [...state[key], ...object[key]]};
                            changed = true;
                        } else {
                            state = {...state, [key]: object[key]};
                            changed = true;
                        }

                        if (changed && (object.length === i)) {
                            callback(state);
                        }
                    }
                }
            } else {
                callback(!this.isEmpty(object) ? object : null);
            }
        };

        changeState(this.state, object, (state) => {
            this.setState(state, () => {
                (typeof (callback) === 'function') && callback(true);
            });
        });
    };

    /**
     *
     * @returns {{value: null, on, on, forceUpdate: (function(*))}}
     */
    forceUpdate = () => {
        return {
            value: null,
            get on() {
                return this.value;
            },
            set on(value) {
                this.value = value;
            },
            forceUpdate(string) {
                this.on = string;
            }
        };
    };


    /**
     *
     * @param field
     * @param value
     * @param callback
     */
    mountObject = (field, value, callback) => {
        let
            fields = field.split('.').reverse(),
            object = value;

        this.recursiveSyncMap(fields, 0, fields.length, (item, next) => {
            object = {[item]: object};
            next(true);
        }, () => {
            (typeof (callback) === 'function') && callback(object);
        });
    };

    /**
     *
     * @param alias
     * @param callback
     * @param delay
     */
    throttle = (alias, callback, delay) => {
        this.$timer[alias] && clearTimeout(this.$timer[alias]);
        this.$timer[alias] = setTimeout(() => {
            (typeof (callback) === 'function') && callback(true);
        }, delay || this.$controller.timer_delay);
    };

    /**
     *
     * @param alias
     */
    clearThrottle = (alias) => {
        clearTimeout(this.$timer[alias]);
    };

    /**
     *
     * @param data
     * @param field
     * @param prefix
     * @param empty
     * @returns {string}
     */
    verifyField = (data, field, prefix, empty) => {
        let array = field.split('.');
        if (this.isArrayIf(array)) {
            let length = array.length, temp = data;
            for (let i = 0; length > i; i++) {
                if (this.isObjectIf(temp) && temp.hasOwnProperty(array[i])) {
                    temp = !this.isEmpty(temp[array[i]]) ? temp[array[i]] : empty;
                } else {
                    temp = empty;
                }
                if (length === (i + 1)) {
                    return ((prefix && !!temp) ? `${prefix}${temp}` : temp);
                }
            }
        }
    };

    /**
     *
     * @param array
     * @param index
     * @param length
     * @param done
     * @param always
     */
    recursiveSyncMap = (array, index, length, done, always) => {
        done(array[index], () => {
            if (length > ++index) {
                this.recursiveSyncMap(array, index, length, (item, next, stop) => {
                    done(item, next, stop);
                }, () => {
                    (typeof (always) === 'function') && always(true);
                })
            } else {
                (typeof (always) === 'function') && always(true);
            }
        }, () => {
            (typeof (always) === 'function') && always(true);
        });
    };

    /**
     *
     * @param element
     * @param type
     * @param reference
     * @param listener
     * @param options
     * @param data
     */
    addListener = (element, type, reference, listener, options, data) => {
        const setListener = () => {
            if (this.isElement(element) || this.isXMLHttpRequest(element) || this.isObjectIf(element)) {
                if (this.verifyField(options, 'passive', false, false)) {
                    options = (Modernizr.passiveeventlisteners ? {passive: true} : false);
                }
                element.removeEventListener(type, listener);
                element.addEventListener(type, listener, options);
                this.$listeners = [...this.$listeners, ...[{
                    reference: reference,
                    listener: element,
                    data: data
                }]];
            }
        };

        if (this.isArrayIf(this.$listeners)) {
            let array = this.$listeners.filter((value) => {
                return (value.reference === reference);
            });
            !this.isArrayIf(array) && setListener();
        } else {
            setListener();
        }
    };

    /**
     *
     * @param type
     * @param reference
     * @param listener
     * @param callback
     */
    removeListener = (type, reference, listener, callback) => {
        const deleteListener = (object) => {
            if (this.isElement(object.listener) || this.isXMLHttpRequest(object.listener) || this.isObjectIf(object.listener)) {
                object.listener.removeEventListener(type, listener);
                this.$listeners = this.$listeners.filter((value) => {
                    return value.reference !== reference;
                });
                (typeof (callback) === 'function') && callback(true);
            }
        };

        if (this.isArrayIf(this.$listeners)) {
            let array = this.$listeners.filter((value) => {
                return value.reference === reference;
            });
            if (Boolean(array.length)) {
                deleteListener(array[0]);
            } else {
                (typeof (callback) === 'function') && callback(true);
            }
        } else {
            (typeof (callback) === 'function') && callback(true);
        }
    };

    /**
     *
     * @param reference
     */
    getListener = (reference) => {
        let array = this.$listeners.filter((value) => {
            return (value.reference === reference);
        });
        if (this.isArrayIf(array)) {
            return array[0];
        }
    };

    /**
     *
     * @param type
     * @param object
     */
    emit = (type, object) => {
        //noinspection JSCheckFunctionSignatures
        document.dispatchEvent(new CustomEvent(type, {detail: object}));
    };

    /**
     *
     * @param type
     * @param callback
     */
    on = (type, callback) => {
        this.addListener(document, type, type, (event) => {
            (typeof (callback) === 'function') && callback(event.detail);
        });
    };

    /**
     *
     * @param value
     * @returns {boolean}
     */
    isEmpty = (value) => {
        return Boolean((value === null) || (typeof (value) === 'undefined') || ((typeof (value) === 'string') && !value.trim()));
    };

    /**
     *
     * @param object
     * @returns {boolean}
     */
    isObject = (object) => {
        return Boolean(!this.isEmpty(object) && (typeof (object) === 'object'));
    };


    /**
     * array-like
     * @param object
     * @returns {boolean}
     */
    isObjectIf = (object) => {
        return Boolean(this.isObject(object) && (((typeof (object.length) !== 'undefined') && object.length) || Object.keys(object).length));
    };

    /**
     *
     * @param array
     * @returns {boolean}
     */
    isArray = (array) => {
        return Boolean(Array.isArray(array));
    };

    /**
     *
     * @param array
     * @returns {boolean}
     */
    isArrayIf = (array) => {
        return Boolean(this.isArray(array) && array.length);
    };

    /**
     *
     * @param array
     * @param value
     * @returns {boolean}
     */
    inArray = (array, value) => {
        return Boolean(this.isArrayIf(array) && (array.indexOf(value) > -1));
    };

    /**
     *
     * @param object
     * @returns {boolean}
     */
    isFunction = (object) => {
        return Boolean(!this.isEmpty(object) && (typeof (object) === 'function'));
    };

    /**
     *
     * @param object
     * @param method
     * @returns {boolean}
     */
    inFunction = (object, method) => {
        return Boolean(this.isObject(object) && (typeof (object[method]) === 'function'));
    };

    /**
     *
     * @param element
     * @returns {boolean}
     */
    isElement = (element) => {
        return Boolean(!this.isEmpty(element) && ((typeof (element.nodeType) !== 'undefined') && ((element.nodeType === Node.ELEMENT_NODE) || (element.nodeType === Node.DOCUMENT_NODE))));
    };

    /**
     *
     * @param object
     * @returns {boolean}
     */
    isXMLHttpRequest = (object) => {
        return (this.isObject(object) && ((typeof (object.constructor) !== 'undefined') && ((object.constructor.name === 'XMLHttpRequest') || (object.constructor.name === 'XMLHttpRequestUpload'))));
    };

    /**
     *
     * @param string
     * @returns {boolean}
     */
    isInteger = (string) => {
        return !this.isEmpty(string) && (/^(\d+)$/g).test(string);
    };

    /**
     *
     * @param string
     * @returns {boolean}
     */
    isIntegerOrFloat = (string) => {
        return !this.isEmpty(string) && (/^(-)?(\d+)(\.)?(\d+)?$/g).test(string);
    };

    /**
     *
     * @param string
     * @returns {boolean}
     */
    isIdCompound = (string) => {
        return !this.isEmpty(string) && (/^(\d+)([A-Z])$/g).test(string);
    };

    /**
     *
     * @param string
     * @returns {boolean}
     */
    isHexColor = (string) => {
        return !this.isEmpty(string) && (/^#([0-9A-F]{6})$/i).test(string);
    };

    /**
     *
     * @param string
     * @returns {boolean}
     */
    isTintColor = (string) => {
        return !this.isEmpty(string) && (/^0x([0-9A-F]{6})$/i).test(string);
    };

    tintToHex = (string) => {
        return this.isTintColor(string) && `#${string.substring(2).toUpperCase()}`;
    };

    /**
     *
     * @param object
     */
    defineObject = (object) => {
        (this.isObjectIf(object) && !object.hasOwnProperty('length')) && Object.defineProperty(object, 'length', {
            get: () => {
                return Object.keys(object).length;
            }
        });
    };

    /**
     *
     * @param element
     * @returns {*}
     */
    elementToArray = (element) => {
        let array = this.isObjectIf(element) && Array.prototype.slice.call(element);
        return this.isArray(array) ? array : [];
    };

    /**
     * @param {array} array
     * @param {array} weight
     * @param {function(Object.<string, object>)} callback
     */
    randomWeight = (array, weight, callback) => {
        let
            total = eval(weight.join('+')),
            arrayWeight = [],
            current = 0;

        while (current < array.length) {
            for (let i = 0; i < weight[current]; i++) {
                arrayWeight[arrayWeight.length] = {value: array[current], index: current};
                if (total === arrayWeight.length) {
                    (typeof (callback) === 'function') && callback(arrayWeight[Math.floor(Math.random() * total)]);
                }
            }
            current++;
        }
    };

    /**
     *
     * @param event
     * @returns {boolean}
     */
    stopPropagation = (event) => {
        event.stopPropagation();
        event.preventDefault();
        // event.cancelBubble = true;
        // event.returnValue = false;
        return false;
    };

    /**
     *
     * @param _LOCATION_
     * @param _SOURCE_
     * @returns {`${string}//${string}${string}`}
     */
    toUri = (_LOCATION_, _SOURCE_) => {
        return `${_LOCATION_.protocol}//${_LOCATION_.host}${_SOURCE_}`;
    };

    /**
     *
     * @param string
     * @returns {false|string}
     */
    toFloat = (string) => {
        return !this.isEmpty(string) && string.toString().replace(/,/g, '.').replace(/[^\d\.-]/g, '');
    };

    /**
     *
     * @param string
     * @returns {*|boolean|number}
     */
    toInteger = (string) => {
        string = this.toFloat(string);
        return this.isIntegerOrFloat(string) && (new Big(string)).round().toNumber();
    };

    /**
     *
     * @param string
     * @returns {*|boolean|string}
     */
    toIntegerOrFloat = (string) => {
        string = this.toFloat(string);
        return this.isIntegerOrFloat(string) && (new Big(string)).round(1, Big.roundUp).toNumber();
    };

    /**
     * % A literal percent character. No argument is required.
     * s The argument is treated and presented as a string.
     * u The argument is treated as an integer and presented as an unsigned decimal number.
     * @param string
     * @returns {*}
     */
    printF = function (string) {
        let args = Array.prototype.slice.call(arguments);

        if (_this.isArrayIf(args)) {
            _this.recursiveSyncMap(args, 1, args.length, (item, next, stop) => {
                switch (typeof (item)) {
                    case 'string':
                        string = string.toString().replace('%s', item);
                        next(true);
                        break;
                    case 'number':
                        string = string.toString().replace('%u', item);
                        next(true);
                        break;
                    default:
                        stop(true)
                }
            });
        }

        return string;
    };

    /**
     * Check and refactor
     */

    /**
     *
     * @param number
     * @param length
     * @returns {string}
     */
    padWithLeadingZeros = (number, length) => {
        return String(number).padStart(length, '0').toString();
    };

    /**
     *
     * @param original
     * @param current
     * @param target
     * @param big
     * @returns {*|number}
     */
    calcSize = (original, current, target, big) => {
        let
            big_original = (new Big(original)),
            big_current = (new Big(current)),
            big_target = (new Big(target));

        /**
         *
         * @param big_original
         * @param big_current
         * @param big_target
         * @returns {number}
         */
        const calcSizeSubtract = (big_original, big_current, big_target) => {
            let big_number = big_target.minus(big_target.div(this.$controller.big_division_100).times(big_original.minus(big_current).div(big_original).times(this.$controller.big_division_100)));
            return big ? big_number : big_number.round(1, Big.roundUp).toNumber();
        };

        /**
         *
         * @param big_original
         * @param big_current
         * @param big_target
         * @returns {*}
         */
        const calcSizeAddition = (big_original, big_current, big_target) => {
            let big_number = big_target.plus(big_target.div(this.$controller.big_division_100).times(big_current.minus(big_original).div(big_original).times(this.$controller.big_division_100)));
            return big ? big_number : big_number.round(1, Big.roundUp).toNumber();
        };

        if (big_original.gte(big_current)) {
            return calcSizeSubtract(big_original, big_current, big_target);
        } else if (big_original.lt(big_current)) {
            return calcSizeAddition(big_original, big_current, big_target);
        }
    };

    /**
     *
     * @param document
     */
    openFullScreen = (document) => {
        if (document.requestFullscreen) {
            document.requestFullscreen();
        } else if (document.webkitRequestFullscreen) { /* Safari */
            document.webkitRequestFullscreen();
        } else if (document.msRequestFullscreen) { /* IE11 */
            document.msRequestFullscreen();
        } else if (document.mozRequestFullScreen) {/* Firefox */
            document.mozRequestFullScreen();
        }
    };

    /**
     *
     * @param document
     */
    closeFullScreen = (document) => {
        if (document.exitFullscreen) {
            document.exitFullscreen();
        } else if (document.webkitExitFullscreen) { /* Safari */
            document.webkitExitFullscreen();
        } else if (document.msExitFullscreen) { /* IE11 */
            document.msExitFullscreen();
        } else if (document.mozCancelFullScreen) {/* Firefox */
            document.mozCancelFullScreen();
        }
    };

    /**
     *
     * @param string
     * @param separator
     * @returns {string|*}
     */
    toSlug = (string, separator) => {
        const sets = [
            {to: 'A', from: '[ÀÁÂÃÄÅĀĂĄẠẢẤẦẨẪẬẮẰẲẴẶ]'},
            {to: 'a', from: '[àáâãäåāăąạảấầẩẫậắằẳẵặª]'},
            {to: 'AE', from: '[Æ]'},
            {to: 'ae', from: '[æ]'},
            {to: 'C', from: '[ÇĆĈČ]'},
            {to: 'c', from: '[çćĉč]'},
            {to: 'D', from: '[ÐĎĐÞ]'},
            {to: 'd', from: '[ðďđþ]'},
            {to: 'E', from: '[ÈÉÊËĒĔĖĘĚẸẺẼẾỀỂỄỆ]'},
            {to: 'e', from: '[èéêëēĕėęěẹẻẽếềểễệ]'},
            {to: 'G', from: '[ĜĞĢǴ]'},
            {to: 'g', from: '[ĝğģǵ]'},
            {to: 'H', from: '[ĤḦ]'},
            {to: 'h', from: '[ĥḧ]'},
            {to: 'I', from: '[ÌÍÎÏĨĪĮİỈỊ]'},
            {to: 'i', from: '[ìíîïĩīįi̇ỉị]'},
            {to: 'J', from: '[Ĵ]'},
            {to: 'j', from: '[ĵ]'},
            {to: 'IJ', from: '[Ĳ]'},
            {to: 'ij', from: '[ĳ]'},
            {to: 'K', from: '[Ķ]'},
            {to: 'k', from: '[ķ]'},
            {to: 'L', from: '[ĹĻĽŁ]'},
            {to: 'l', from: '[ĺļľł]'},
            {to: 'M', from: '[Ḿ]'},
            {to: 'm', from: '[ḿ]'},
            {to: 'N', from: '[ÑŃŅŇ]'},
            {to: 'n', from: '[ñńņň]'},
            {to: 'O', from: '[ÒÓÔÕÖØŌŎŐỌỎỐỒỔỖỘỚỜỞỠỢǪǬƠ]'},
            {to: 'o', from: '[òóôõöøōŏőọỏốồổỗộớờởỡợǫǭơº]'},
            {to: 'OE', from: '[Œ]'},
            {to: 'oe', from: '[œ]'},
            {to: 'P', from: '[Ṕ]'},
            {to: 'p', from: '[ṕ]'},
            {to: 'R', from: '[ŔŖŘ]'},
            {to: 'r', from: '[ŕŗř]'},
            {to: 'S', from: '[ŚŜŞŠ]'},
            {to: 's', from: '[śŝşš]'},
            {to: 'SS', from: '[ẞ]'},
            {to: 'ss', from: '[ß]'},
            {to: 'T', from: '[ŢŤ]'},
            {to: 't', from: '[ţť]'},
            {to: 'U', from: '[ÙÚÛÜŨŪŬŮŰŲỤỦỨỪỬỮỰƯ]'},
            {to: 'u', from: '[ùúûüũūŭůűųụủứừửữựư]'},
            {to: 'W', from: '[ẂŴẀẄ]'},
            {to: 'w', from: '[ẃŵẁẅ]'},
            {to: 'X', from: '[Ẍ]'},
            {to: 'x', from: '[ẍ]'},
            {to: 'Y', from: '[ÝŶŸỲỴỶỸ]'},
            {to: 'y', from: '[ýŷÿỳỵỷỹ]'},
            {to: 'Z', from: '[ŹŻŽ]'},
            {to: 'z', from: '[źżž]'},
            {to: '-and-', from: '[&]'},
            {to: '-', from: '[_]'}
        ];

        string = string.toString().trim();

        sets.forEach((set) => {
            string = string.replace(new RegExp(set.from, 'g'), set.to);
        });

        string = string.split(/(?=[A-Z])/).join('-').toLowerCase();

        string = string.replace(/\s+/g, '-')  /* Replace spaces with - */
            .replace(/[^\w-]/g, '')           /* Remove all non-word chars */
            .replace(/-+/g, '-')              /* Replace multiple - with single - */
            .replace(/^-+/, '')               /* Trim - from start of text */
            .replace(/-+$/, '');
        /* Trim - from end of text */

        if ((typeof (separator) !== 'undefined') && (separator !== '-')) {
            string = string.replace(/-/g, separator);
        }

        return string;
    };

    /**
     *
     * @param string
     * @returns {boolean|*}
     */
    toNumber = (string) => {
        !this.isEmpty(string) && (string = Number(string.toString().replace(/\D/g, '')));
        return (typeof (string) === 'number') && string;
    };

    /**
     *
     * @param string
     * @returns {boolean|*}
     */
    toRawLower = (string) => {
        !this.isEmpty(string) && (string = string.toString().replace(/[^a-zA-Z0-9]/g, '').toLowerCase());
        return (typeof (string) === 'string') && string;
    };

    /**
     *
     * @param string
     * @returns {boolean|String}
     */
    removeSpaceDuplicate = (string) => {
        return Boolean(string) && string.replace(/\s+/g, ' ');
    };

    /**
     *
     * @param name
     * @returns {boolean}
     */
    removeArrayInput = (name) => {
        return Boolean(name) && name.replace(/\[]$/, '');
    };

    /**
     *
     * @param name
     * @returns {boolean}
     */
    checkArrayInput = (name) => {
        return (/\[]$/).test(name);
    };
}

export default HelpersController;